import gql from "graphql-tag";

export const IcanResultFragment = gql`
    fragment IcanResultFragment on IcanResult {
        resultDateTime
        icanId
        icanResult
    }
`